<div class="mat-dialog-container-in">
	<div class="dialog-box delete-dialog-box">
		<div class="dialog-icon dialog-icon-question"></div>
		<div class="dialog-content">
			<h1 mat-dialog-title>{{data.text}} {{data.id}}</h1>
		</div>
		<div class="dialog-subtext">{{data.subtext}}</div>
		<div class="dialog-line-buttons">
			<button mat-dialog-close>{{ 'dont_delete' | translate }}</button>
		    <button mat-dialog-close="del">{{data.action}}</button>	    
		</div>
	</div>
</div>